import VendorSearchResultsHtml from '../../app-lite/vendors/templates/vendors.search.results.html';

export function AshdownSettingsCtrl (
  $state,
  $scope,
  $translate,
  confirm,
  messages,
  settings,
  streamSearch,
  Vendor,
  workshopAPI
) {
  $scope.loaded = true;
  $scope.settings = settings;

  $scope.activate = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', {name:"Ashdown Ingram"}))
      .then(function () {
        return workshopAPI.get('/company/add_ashdown_ingram');
      }).then(function () {
        messages.show($translate.instant('JS_SPACE.INTEGRATIONS.ACTIVATED', {name:"Ashdown Ingram"}), 'success');
        $state.reload();
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.deactivate = function () {
    confirm.generic($translate.instant('JS_SPACE.INTEGRATIONS.DEACTIVATE', {name:"Ashdown Ingram"}))
      .then(function () {
        return workshopAPI.get('/company/remove_ashdown_ingram');
      }).then(function () {
        $state.reload();
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.save = function () {
    workshopAPI.patch('/company', $scope.settings, 'company')
      .then(function () {
        messages.show($translate.instant('JS_SPACE.MESSAGES.SAVED.SETTINGS'), 'success');
        $state.reload();
      }, function (err) {
        messages.error(err);
      });
  };

  $scope.vendorSearch = {
    list: [],
    selected: {
      id: $scope.settings.ashdown_ingram_vendor_id,
      company_name: $scope.settings.ashdown_ingram_settings.ashdown_ingram_vendor_name,
    },
    search (typed) {
      const self = this;

      return streamSearch.search('vendors', typed).then(function (vendors) {
        return self.list.concat(vendors);
      });
    },
    new () {
      const self = this;

      Vendor.quickAdd().then(vendor => {
        self.selected = vendor;

        $scope.settings.ashdown_ingram_vendor_id                           = vendor.id;
        $scope.settings.ashdown_ingram_settings.ashdown_ingram_vendor_name = vendor.company_name;

        messages.show($translate.instant('JS_SPACE.INTEGRATIONS.SUPPLIER_FOR_INTEGRATION'), 'success');
      });
    },
    choose (vendor) {
      $scope.settings.ashdown_ingram_vendor_id = vendor.id;
      $scope.settings.ashdown_ingram_settings.ashdown_ingram_vendor_name = vendor.company_name;
    },
    format (vendor) {
      return vendor ? vendor.company_name: '';
    },
    resultsTemplateUrl: VendorSearchResultsHtml
  };
}
